import { CompetencyDetailsRaw } from '../types/competencyDetails';
import { CompetencyDetails } from '../types/competencyDetailsAdapter';

export const competencyDetailsAdapter = (competencyDetails: CompetencyDetailsRaw): CompetencyDetails => ({
  name: competencyDetails.competencyName,
  isDetailAccessible: competencyDetails.isDetailAccessible,
  progress: competencyDetails.label,
  progressPercentage: competencyDetails.displayScore,
  maxScore: competencyDetails.labelConfig.maxRating,
  competencyDescription: competencyDetails.competencyDescription,
  activity: competencyDetails.scoreHistory?.map((activity, i) => ({
    createdTS: activity?.changeOn ? new Date(activity.changeOn) : null,
    progressPercentage: activity?.displayScore,
    previousProgressPercentage: competencyDetails.scoreHistory[i - 1]?.displayScore ?? 0.0,
    previousProgress: competencyDetails.scoreHistory[i - 1]?.label ?? '',
    currentProgress: activity?.label,
    employeeProfile: {
      id: activity?.changeByEmployee?.id,
      displayName: activity?.changeByEmployee?.displayName,
      profilePhoto: activity?.changeByEmployee?.profilePhoto,
      preferredName: activity?.changeByEmployee?.preferredName,
      designation: activity?.changeByEmployee?.designation,
      employeeFunction: activity?.changeByEmployee?.employeeFunction,
      email: activity?.changeByEmployee?.email,
    },
    reviewCycle: activity.changeByReviewCycle,
    changeSource: activity?.changeSource,
    comment: activity.comment
      ? {
          text: activity.comment.text,
          macros: activity.comment.macros,
          from: {
            id: activity.comment.from?.uuid,
            displayName: activity.comment.from?.metadata?.displayName,
            profilePhoto: activity.comment.from?.profile?.profilePhoto,
          },
          createdTS: activity.comment.createdTS,
        }
      : null,
  })),
  progressStages:
    competencyDetails.labelConfig?.answerOptions?.map((stage) => ({
      id: stage.id,
      progress: stage.description,
      progressPercentage: stage.score,
    })) ?? [],
});
